// extracted by mini-css-extract-plugin
export var black = "webinarService-module--black--5a64e";
export var bottom_wrapper = "webinarService-module--bottom_wrapper--36a64";
export var div_box = "webinarService-module--div_box--f0eaa";
export var left_box = "webinarService-module--left_box--3ae8d";
export var left_box_inner = "webinarService-module--left_box_inner--0bb5f";
export var link_btn = "webinarService-module--link_btn--962c8";
export var mix_heading = "webinarService-module--mix_heading--06979";
export var red = "webinarService-module--red--66daf";
export var right_box = "webinarService-module--right_box--ddcf8";
export var service_section = "webinarService-module--service_section--ff4a9";
export var service_wrapper = "webinarService-module--service_wrapper--a677e";
export var text_box = "webinarService-module--text_box--af255";